import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useDispatch } from 'react-redux';
import Small from 'UIComponents/elements/Small';
import { NextStepManager } from '../flow-management/NextStepManager';
import { setNextStep } from '../flow-management/setNextStep';
import { StyledUILink } from '../views-components/TextInput.styles';
import { Step } from 'signup-constants/Step';
import { useIsFramedCentredModalStep } from '../hooks/useIsFramedCerntredModalStep';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const ResendCodeFooter = () => {
  const stepKey = Step.CodeVerification;
  const dispatch = useDispatch();
  const {
    isFramedCentredModalStep
  } = useIsFramedCentredModalStep();
  const goToResendEmailStep = event => {
    event.preventDefault();
    return dispatch(setNextStep({
      rebuilder: NextStepManager.pushNextSteps(Step.ResendEmail)
    }));
  };
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    marginBlockStart: isFramedCentredModalStep ? '300' : '600',
    children: /*#__PURE__*/_jsx(Text, {
      as: "div",
      textAlign: isFramedCentredModalStep ? 'center' : undefined,
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link: StyledUILink,
            strong: ({
              children
            }) => /*#__PURE__*/_jsx("span", {
              children: children
            }),
            br: () => {
              return isFramedCentredModalStep && /*#__PURE__*/_jsx("br", {});
            }
          },
          message: `views.${stepKey}.cantSeeEmail_jsx`,
          options: {
            onClick: goToResendEmailStep,
            href: ''
          }
        })
      })
    })
  });
};
export default ResendCodeFooter;